<mat-card *ngIf="message && message.type === 'error'" class="mat-elevation-z0 flex flex-row gap-6">
  <mat-icon
    *ngIf="message.type === 'error'"
    class="error !text-mat-ef-revolution-primary-500"
    svgIcon="error_outline"
  ></mat-icon>
  <p class="font-efSans-primary" innerHTML="{{ message.summary }}"></p>
</mat-card>
